const acOvTheme = {
  _societyLocale: 'es_ES',
  _societyCurrency: 'EUR',
  _loaded: false,
  _inits: [],
  getCurrency: function () {
    return acOvTheme._societyCurrency || 'EUR'
  },
  getLocale: function () {
    return acOvTheme._societyLocale || 'es_ES'
  },
  /**
   * Gets if the number is empty, false, zero, ...
   */
  isEmptyNumber: function (value) {
    return value === ''
      || value === '0'
      || value === 'null'
      || value === 'undefined'
      || value === 'false'
      || value === false
      || value === undefined
      || (typeof value === 'number' && isNaN(value))
      || value === 0
  },
  addInit: function (callback) {
    acOvTheme._inits.push(callback)
  },
  /**
   * Formats a decimal value as currency.
   *
   * The input value must be a valid decimal value.
   *
   * @param value Value to format
   * @param showZero Whether to show empty values as 0 or as an empty string
   * @param currency Currency to apply the format from. Defaults to "EUR"
   * @param locale Locale to format values. Defaults to es_ES
   * @returns
   */
  formatCurrency: function (value, showZero, currency, locale) {
    showZero = typeof showZero === 'undefined' ? true : (showZero ? true : false)
    currency = currency || acOvTheme.getCurrency()
    locale = locale || acOvTheme.getLocale()

    let isEmptyValue = acOvTheme.isEmptyNumber(value)

    if (isEmptyValue) {
      return showZero ? '0' : ''
    }

    let languageId = locale.replace('_', '-')
    let result = ''

    if (currency !== '' && languageId !== '') {
      let formatter = new Intl.NumberFormat(languageId, {
        style: 'currency',
        currency: currency
      })

      let rawValue = acOvTheme.unFormatCurrency(value)
      let floatValue = parseFloat(rawValue)

      if (isNaN(floatValue)) {
        return ''
      } else {
        result = formatter.format(floatValue)
      }
    } else {
      window.console && console.error('No currency nor locale id set', currency, locale, languageId)
      result = value + ''
    }

    return result
  },
  unFormatCurrency: function (valueStr, decimalSeparator) {
    valueStr = valueStr.toString()
    if (acOvTheme.isEmptyNumber(valueStr)) {
      return ''
    }

    // Capture the amount without currency symbol
    let valueRegex = new RegExp('[0-9\.,]+')
    let matches = valueStr.match(valueRegex)

    if (matches.length != 1) {
      return valueStr
    }

    let value = matches[0]
    let commaIndex = value.lastIndexOf(',')
    let dotIndex = value.lastIndexOf('.')

    if (typeof decimalSeparator === 'undefined') {
      if (commaIndex > dotIndex) {
        decimalSeparator = ','
      } else {
        decimalSeparator = '.'
      }
    }

    // Normalize number to dot-decimal separator and remove thousands separator
    let thousandSeparator = decimalSeparator === '.' ? ',' : '.'
    value = value.replace(thousandSeparator, '').replace(decimalSeparator, '.')

    return value
  },

  handleAllNovalidateForms: function () {
    window.console && console.debug('Handle all novalidate forms')

    jQuery('form[novalidate]').each(function (pos, form) {
      if (!jQuery(form).hasClass('.tramite-form')) {
        acOvTheme.handleValidation(form)
      }
    })
  },

  handleValidation: function (form) {
    let frm = null

    if (typeof form === 'string') {
      frm = jQuery('#' + form)
    } else if (form instanceof HTMLFormElement) {
      frm = jQuery(form)
    } else if (typeof form.jquery === 'string') {
      frm = form
    } else {
      window.console && console.debug('Cannot handle validation of unkonwn element')
      return
    }

    let handled = frm.attr('data-ov-validation-handled') === 'true'

    if (handled) {
      return
    }

    frm.attr('data-ov-validation-handled', 'true')

    // Ensure validation is off
    if (!frm.prop('novalidate')) {
      frm.prop('novalidate', true)
    }

    // Trigger validation report each time a form element is updated
    frm.find('input, textarea, select').on('change keyup', function (ev) {
      let jElem = jQuery(ev.target)
      if (jElem.is(':hidden')) {
        window.console && console.debug('Form elem hidden ' + jElem.attr('name'))
        ev.target.setCustomValidity('')
        return
      }

      if (!ev.target.reportValidity()) {
        // Element invalid
        window.console && console.debug('Form elem invalid ' + jElem.attr('name'))
      } else {
        window.console && console.debug('Form elem valid ' + jElem.attr('name'))
      }
    })

    // When focused report validity
    frm.find('input, textarea, select').on('focusin', function (ev) {
      ev.target.reportValidity()
    })

    // Invalid hidden elements must not be shown as invalid
    frm.find('input, textarea, select').on('invalid', function (ev) {
      let jElem = jQuery(ev.target)
      if (jElem.is(':hidden')) {
        ev.target.setCustomValidity('')
        window.console && console.debug('Form elem invalid but hidden ' + jElem.attr('name'))
      }
    })

    frm.on('submit', function (ev) {
      let invalidElement = null

      jQuery(ev.target).find('input, textarea, select').each(function (pos, elem) {
        let visible = jQuery(elem).is(':visible')

        if (!visible) {
          // Not visible elements must be always valid
          elem.setCustomValidity('')
          return true
        } else if (!elem.reportValidity()) {
          invalidElement = elem
          // break on first invalid element on submit. This will also focus the element.
          return false
        }
      })

      if (invalidElement !== null) {
        ev.preventDefault()
        // Hide wait spinner
        jQuery('#wait-load').hide()

        if (!acOvTheme.isElemInViewport(invalidElement)) {
          let top = jQuery(invalidElement).offset().top - 60
          jQuery(invalidElement).scrollTop(top - 100)
        }
      }
    })
  },

  isElemInViewport: function (elem) {
    let jElem = jQuery(elem)
    let jWindow = jQuery(window)
    let elementTop = jElem.offset().top
    let elementBottom = elementTop + jElem.outerHeight()

    let viewportTop = jWindow.scrollTop()
    let viewportBottom = viewportTop + jWindow.height()

    return elementBottom > viewportTop && elementTop < viewportBottom
  },

  onLoad: function () {
    if (acOvTheme._loaded) {
      return
    }

    acOvTheme._loaded = true
    acOvTheme.setFooter()
    acOvTheme.hideSegmentExperienceHeader()
    window.console && console.debug('acOvTheme library loaded')
  },
  // Sets the currency and locale
  setI18N: function (currency, locale) {
    acOvTheme._societyCurrency = currency || 'EUR'
    acOvTheme._societyLocale = locale || themeDisplay.getLanguageId()

    for (var index = 0; index < acOvTheme._inits.length; index++) {
      let callback = acOvTheme._inits[index]
      if (typeof callback === 'function') {
        try {
          callback()
        } catch (e) {
          window.console && console.debug('Init callback failed at index ' + index, e)
        }
      }
    }

    window.console && console.debug('acOvTheme init. Currency: ' + acOvTheme._societyCurrency + ', Locale: ' + acOvTheme._societyLocale)
  },
  initTramites: function () {

  },
  hideWait: function () {
    jQuery('#wait-load').hide()
  },
  showWait: function () {
    jQuery('#wait-load').show()
  },
  validateIBAN: async function (iban) {
    return await validationsUtil.validateIBAN(iban)
  },
  validateDocument: function (document) {
    return validationsUtil.validateDocument(document)
  },
  validateDNI: function (document) {
    return validationsUtil.validateDNI(document)
  },
  validateNIE: function (document) {
    return validationsUtil.validateNIE(document)
  },
  validateCIF: function (document) {
    return validationsUtil.validateCIF(document)
  },
  validateEmail: function (value) {
    return validationsUtil.validateEmail(value)
  },
  validatePostalCode: function (value) {
    return validationsUtil.validatePostalCode(value)
  },
  toggleSelectValidateStyle: function (element) {
    if (typeof element === 'object' && element !== null) {
      if (typeof element.jquery !== 'undefined') {
        element = element[0]
      }

      element.classList.toggle('correct', element.value)
      element.classList.toggle('wrong', !element.value)
    }
  },
  updateNavigationStepper: function (containerId, step) {
    let stepperItems = document.querySelectorAll('#' + containerId + ' .step-items .step-item')
    for (let i = 0; i < stepperItems.length; i++) {
      let classList = stepperItems[i].classList
      if (i < step - 1) {
        classList.remove('step-current')
        classList.remove('step-last-done')
        classList.remove('step-next')
        classList.remove('step-pending')
        classList.add('step-done')
      } else if (i === step - 1) {
        classList.remove('step-current')
        classList.remove('step-next')
        classList.remove('step-pending')
        classList.add('step-last-done')
        classList.add('step-done')
      } else if (i === step && i < stepperItems.length - 1) {
        classList.remove('step-done')
        classList.remove('step-next')
        classList.remove('step-last-done')
        classList.add('step-pending')
        classList.add('step-current')
      } else if (i === step && i === stepperItems.length - 1) {
        classList.remove('step-done')
        classList.remove('step-next')
        classList.remove('step-last-done')
        classList.remove('step-pending')
        classList.add('step-current')
        document.querySelector('#authorized-modal .step-last-done').classList.remove('step-last-done')
      } else if (i === step + 1) {
        classList.remove('step-current')
        classList.remove('step-done')
        classList.remove('step-last-done')
        classList.add('step-pending')
        classList.add('step-next')
      } else {
        classList.remove('step-current')
        classList.remove('step-done')
        classList.remove('step-next')
        classList.remove('step-last-done')
        classList.add('step-pending')
      }
    }
  },
  isMobileViewport: (window.innerWidth <= 500 && window.innerWidth <= window.innerHeight)
    || (window.innerWidth <= 950 && window.innerWidth > window.innerHeight),
  isTabletViewport: (window.innerWidth > 500 && window.innerWidth <= 768 && window.innerWidth <= window.innerHeight)
    || (window.innerWidth > 768 && window.innerWidth <= 500 && window.innerWidth > window.innerHeight),
  isSmallScreen: window.innerWidth > 768 && window.innerWidth <= 900 && window.innerWidth > window.innerHeight,
  loadClasses: function () {
    let elements = document.querySelectorAll('[data-class]')
    for (let el of elements) {
      let defaultClassesList = el.dataset.class.split(' ')
      if (acOvTheme.isMobileViewport) {
        let classList = el.dataset.classMobile !== undefined ? el.dataset.classMobile.split(' ') : defaultClassesList
        acOvTheme.addClassList(el, classList)
      } else if (acOvTheme.isTabletViewport) {
        let classList = el.dataset.classTablet !== undefined ? el.dataset.classTablet.split(' ') : defaultClassesList
        acOvTheme.addClassList(el, classList)
      } else if (acOvTheme.isSmallScreen) {
        let classList = el.dataset.classSmallScreen !== undefined ? el.dataset.classSmallScreen.split(' ') : defaultClassesList
        acOvTheme.addClassList(el, classList)
      } else {
        acOvTheme.addClassList(el, defaultClassesList)
      }
      delete el.dataset.class
      delete el.dataset.classMobile
      delete el.dataset.classTablet
      delete el.dataset.classSmallScreen
    }
  },
  addClassList: function (el, classList) {
    if (el && classList) {
      if (typeof classList === 'string') {
        classList = classList.split(' ')
      }
      for (const className of classList) {
        if (className)
          el.classList.add(className)
      }
    }
  },
  removeClasses: function (el, classList) {
    if (el && classList) {
      if (typeof classList === 'string') {
        classList = classList.split(' ')
      }
      for (const className of classList) {
        if (className)
          el.classList.remove(className)
      }
    }
  },
  createSpinner: function (id, classNames, styles) {
    let spinner = document.createElement('div')
    spinner.id = id
    spinner.dataset.testid = id
    spinner.classList.add('spinner')
    spinner.setAttribute('role', 'status')
    spinner.setAttribute('aria-live', 'polite')

    acOvTheme.addClassList(spinner, classNames)

    if (styles)
      spinner.style = styles

    let bounceOne = document.createElement('div')
    bounceOne.classList.add('double-bounce1')

    let bounceTwo = document.createElement('div')
    bounceTwo.classList.add('double-bounce2')

    spinner.appendChild(bounceOne)
    spinner.appendChild(bounceTwo)
    return spinner
  },
  setFooter: function () {
    window.onload = function () {
      let isScrollable = document.documentElement.clientHeight && document.body.scrollHeight > window.innerHeight
      let footer = document.getElementById('footer')

      if (footer && !isScrollable && !acOvTheme.isMobileViewport) {
        footer.parentElement.style.minHeight = 'calc(100vh - ' + footer.offsetHeight + 'px)'
        footer.style.bottom = (footer.offsetHeight * -1) + 'px'
      }
      footer.classList.remove('invisible')
    }
  },
  hideSegmentExperienceHeader: function () {
    let ids = ['20156']
    document.addEventListener('DOMContentLoaded', function () {
      if (ids.includes(themeDisplay.getUserId()) && location.href.toLowerCase().includes('segmentsexperience')) {
        document.querySelector('header#banner').style.display = 'none'
        document.querySelector('#wrapper').style.overflow = 'visible'
      }
    })
  },
  parseUrlParameter: function (parameterValue) {
    if (parameterValue != undefined) return parameterValue.replace(/\./g, '')
    else return parameterValue
  },
  /**
   * Initializes keyboard navigation and item activation for interactive UI elements like tabs or lists.
   *
   * @function
   * @name acOvTheme.initializeTabs
   * @param {Object} options - Configuration options for the function.
   * @param {string} options.containerSelector - Selector for the main container that holds the items.
   * @param {string} options.itemSelector - Selector for the focusable items (e.g. <li>, [role="tab"], etc.).
   * @param {string} [options.clickTargetSelector=null] - Optional selector for a child element to receive a click (e.g. 'a' inside a tab).
   * @param {boolean} [options.focusContentOnTab=false] - Whether to move focus to the first element inside the active panel when pressing Tab.
   * @param {boolean} [options.activateOnArrow=true] - Whether items should be activated when navigating with arrow keys.
   * @param {boolean} [options.applyAriaSelected=false] - If true, automatically sets aria-selected for accessibility support.
   * @param {function} [options.activateCallback=null] - Optional custom function that runs when an item is activated.
   *
   * @example
   * acOvTheme.initializeTabs({
   *   containerSelector: '.nav-pills',
   *   itemSelector: '[role="presentation"]',
   *   clickTargetSelector: 'a',
   *   focusContentOnTab: true,
   *   activateOnArrow: true,
   *   applyAriaSelected: false,
   *   activateCallback: (tab) => {
   *     tab.setAttribute('aria-selected', 'true');
   *     tab.querySelector('a')?.click();
   *   }
   * });
   */
  initializeTabs: (options) => {
    const {
      containerSelector,
      itemSelector,
      clickTargetSelector = null,
      focusContentOnTab = false,
      activateOnArrow = true,
      applyAriaSelected = false,
      activateCallback = null
    } = options

    document.querySelectorAll(containerSelector).forEach(container => {
      const items = Array.from(container.querySelectorAll(itemSelector))

      items.forEach((item, index) => {
        item.setAttribute('tabindex', '0')

        item.addEventListener('keydown', (e) => {
          let newIndex

          switch (e.key) {
            case 'Enter':
            case ' ':
              e.preventDefault()
              if (clickTargetSelector) {
                item.querySelector(clickTargetSelector)?.click()
              } else {
                item.click()
              }
              if (activateCallback) activateCallback(item)
              if (applyAriaSelected) setAriaSelected(items, newIndex)
              break
            case 'ArrowRight':
            case 'ArrowDown':
              e.preventDefault()
              newIndex = (index + 1) % items.length
              items[newIndex].focus()
              if (activateOnArrow && activateCallback) activateCallback(items[newIndex])
              if (applyAriaSelected) setAriaSelected(items, newIndex)
              break
            case 'ArrowLeft':
            case 'ArrowUp':
              e.preventDefault()
              newIndex = (index - 1 + items.length) % items.length
              items[newIndex].focus()
              if (activateOnArrow && activateCallback) activateCallback(items[newIndex])
              if (applyAriaSelected) setAriaSelected(items, newIndex)
              break
            case 'Tab':
              if (focusContentOnTab) {
                e.preventDefault()
                const panel = document.querySelector('.tab-content .active, .tab-pane.show.active')
                const focusable = panel?.querySelectorAll(
                  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])'
                )
                if (focusable?.length) {
                  focusable[0].focus()
                }
              }
              break
            default:
              return
          }
        })

        item.addEventListener('click', () => {
          if (clickTargetSelector) item.querySelector(clickTargetSelector)?.click()
          if (activateCallback) activateCallback(item)
          if (applyAriaSelected) setAriaSelected(items, item)
        })

        const setAriaSelected = (items, target) => {
          items.forEach(i => i.setAttribute('aria-selected', 'false'))

          if (typeof target === 'number') {
            items[target].setAttribute('aria-selected', 'true')
          } else if (target instanceof Element) {
            target.setAttribute('aria-selected', 'true')
          }
        }
      })
    })
  }
}

window.acOvTheme = acOvTheme
acOvTheme.onLoad()

if (typeof module !== 'undefined' && module.exports) {
  module.exports = acOvTheme
}

Object.defineProperty(String.prototype, 'capitalize', {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase()
  },
  enumerable: false
})